import {clsx} from 'clsx';
import type {
  Overwrite,
  UseComboboxGetInputPropsOptions,
  UseComboboxGetInputPropsReturnValue,
} from 'downshift';
import {memo} from 'react';

import {Icon} from '../../../atoms/icon/index.js';
import * as styles from './style.module.scss';

type SearchProps<Options> = {
  isHidden?: boolean;
  placeholder?: string;
} & Overwrite<UseComboboxGetInputPropsReturnValue, Options>;

const Search = memo(function Input({
  placeholder = 'Search or enter value',
  isHidden = false,
  ...props
}: SearchProps<UseComboboxGetInputPropsOptions>) {
  const classes = clsx(styles.input, {
    [styles.hidden]: isHidden,
  });

  return (
    <div className={classes}>
      <Icon name="search" size={12} color="body-accent" />
      <input {...props} placeholder={placeholder} />
    </div>
  );
});

export {Search};
